module.exports = __webpack_public_path__ + "static/media/icon-supplies-tichel.42ba89af.svg";